import lazyLoading from "./lazyLoading";

export default {
  name: "check",
  path: "/check",
  component: lazyLoading("check/Check"),
  meta: {
    default: false,
    title: "Prijem uzoraka",
    class: "info",
    show: false,
    iconClass: "glyphicon glyphicon-check",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/check.js